var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters['loading'])?_c('v-overlay',{attrs:{"z-index":"10","color":"#000000","opacity":".6"}},[_c('hollow-dots-spinner',{attrs:{"animation-duration":2500,"size":65}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }